

window.addEventListener('load', function() {
  setTimeout(function() {
    function scrollToTop() {
      window.scrollTo({
        top: window.scrollY,
        behavior: 'smooth'
    });
    }
    
    // Iniciar el bucle de desplazamiento cada 0.02 segundos
    var scrollInterval = setInterval(scrollToTop, 20);
    
    setTimeout(function() {
      clearInterval(scrollInterval);
    }, 100);
  }, 900);
});